export function getAll() {
  return [
    {
      value: 0,
      name: "Yes",
      text: "是",
    },
    {
      value: 1,
      name: "No",
      text: "否",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
